export default {

    methods: {
        setContactName () {
            if (this.form.first_names && !this.contactNameSet && !this.form.contact_name) {
                let fullFirstNames = this.form.first_names;
                this.form.contact_name = fullFirstNames.replace(/ .*/, "");
                this.contactNameSet = false;
            }
        },
    },

    watch: {
        "form.email": function (newVal) {
            if (newVal) {
                this.form.email = newVal.replace(/[^a-zA-Z0-9_/\-@.]/g, "").toLowerCase().trim();
            }
        },

        "form.mobile": function (newVal) {
            if (newVal) {
                this.form.mobile = newVal.replace(/\D/g, "").trim();
            }
        },

        "form.phone": function (newVal) {
            if (newVal) {
                this.form.phone = newVal.replace(/\D/g, "").trim();
            }
        },

        "form.vat_number": function (newVal) {
            if (newVal) {
                this.form.vat_number = newVal.replace(/\D/g, "").trim();
            }
        },

        "form.represents_juristic_entity": function (newVal) {
            if (!newVal) {
                this.form.vat_number = "";
            }
        },

    }

};
